import { z } from 'zod';

export const notaInstallmentSchema = z.object({
  numero: z.number(),
  valor: z.number().min(0.01, 'Valor da parcela deve ser maior que zero.'),
  vencimento: z.string().min(1, 'Informe o vencimento.'),
});

// paymentConditionId/Name não persistem na nota (Invoice não tem essa FK): servem só
// para gerar as parcelas na tela; o que é salvo é payments[] + installments[].
export const notaPagamentoSchema = z
  .object({
    paymentMethodId: z.number().optional(),
    paymentMethodName: z.string().optional(),
    paymentConditionId: z.number().optional(),
    paymentConditionName: z.string().optional(),
    descricao: z.string().optional(),
    installments: z
      .array(notaInstallmentSchema)
      .min(1, 'Escolha uma condição de pagamento para gerar as parcelas.'),
  })
  .superRefine((data, ctx) => {
    if (!data.paymentMethodId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Selecione a forma de pagamento.',
        path: ['paymentMethodId'],
      });
    }
    if (data.paymentMethodName === 'Outros' && !data.descricao?.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'A forma "Outros" exige uma descrição.',
        path: ['descricao'],
      });
    }
  });

export type NotaInstallmentFormValues = z.infer<typeof notaInstallmentSchema>;
export type NotaPagamentoFormValues = z.infer<typeof notaPagamentoSchema>;
